module.exports = __webpack_public_path__ + "img/HR.f823580c.svg";